// RouteWatcher.js
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { global_var } from "./cs-lab-config";

export default function RouteWatcher({ children }) {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if(!global_var.pathStack){
      global_var.pathStack = []
      global_var.pathStack.push(location.pathname);
    }

    if(global_var.pathStack.indexOf(location.pathname) === -1 && global_var.pathStack.indexOf(prevPath.current) === -1 && prevPath.current !== location.pathname){
      global_var.pathStack.push(prevPath.current);
    }
    else if(global_var.pathStack.indexOf(location.pathname) !== -1){
      global_var.pathStack = global_var.pathStack.slice(0, global_var.pathStack.indexOf(location.pathname));
    }

    prevPath.current = location.pathname;
  }, [location]);

  return children;
}
